module.exports = __webpack_public_path__ + "img/veza-4NP.6082fb49.png";